import { BookingType } from "@b2bportal/core-types";
import { EmailType } from "@b2bportal/email-api";

export function getResendEmailType(
  reservationType: BookingType,
  isLuxury = false
): EmailType {
  switch (reservationType) {
    case BookingType.Flight:
      return EmailType.flight_whats_next;
    case BookingType.Ground:
      return EmailType.ground_booking_confirmation;
    case BookingType.Lodging:
      return isLuxury
        ? EmailType.premier_hotel_booking_confirmation
        : EmailType.hotel_booking_confirmation;
    case BookingType.Package:
      return EmailType.package_booking_confirmation;
    case BookingType.Activities:
      return EmailType.activities_booking_confirmation;
    case BookingType.Homes:
      return EmailType.homes_booking_confirmation;
    default:
      throw new Error(`Unsupported reservation type: ${reservationType}`);
  }
}
